// extracted by mini-css-extract-plugin
export default {"editButton":"addLoans_editButton__lhlrB","TableBody":"addLoans_TableBody__KLg6R","deleteButton":"addLoans_deleteButton__mpsXX"};